export default "__VITE_ASSET__1819b2bc__"